import { EmailDailyStat, EmailEvent } from 'services';

/** Chaves de `EmailDailyStat` que viram indicador na tela. */
export type MetricKey = Exclude<keyof EmailDailyStat, '_id' | 'opened_unique' | 'clicked_unique' | 'queued'>;

export interface EmailMetric {
  key: MetricKey;
  label: string;
  color: string;
  help: string;
  /** Indicadores marcados também viram série do gráfico de evolução diária. */
  chart?: boolean;
}

export const EMAIL_METRICS: EmailMetric[] = [
  {
    key: 'sent',
    label: 'Enviados',
    color: '#4E79A7',
    chart: true,
    help: 'A MailerSend entregou a mensagem ao servidor do destinatário e ele aceitou recebê-la. Ainda não é garantia de que chegou à caixa de entrada.',
  },
  {
    key: 'delivered',
    label: 'Entregues',
    color: '#59A14F',
    chart: true,
    help: 'O servidor do destinatário confirmou a entrega na caixa. É este número que significa "chegou". Pode aparecer num dia posterior ao do envio, porque cada evento é datado de quando aconteceu.',
  },
  {
    key: 'opened',
    label: 'Aberturas',
    color: '#F28E2B',
    chart: true,
    help: 'Total de aberturas, contando repetições: uma pessoa que abre 5 vezes soma 5. Para saber quantas pessoas distintas abriram, veja a taxa de abertura. Número aproximado: o Apple Mail infla e quem bloqueia imagens não é contado.',
  },
  {
    key: 'clicked',
    label: 'Cliques',
    color: '#B07AA1',
    chart: true,
    help: 'Total de cliques em links rastreados, contando repetições. É o dado mais confiável de engajamento — não há como clicar sem ter aberto de verdade.',
  },
  {
    key: 'hard_bounced',
    label: 'Hard bounce',
    color: '#E15759',
    help: 'Recusa permanente: o endereço não existe. Nunca será reenviado. Filtre a tabela por este evento para achar os cadastros com e-mail inválido.',
  },
  {
    key: 'soft_bounced',
    label: 'Soft bounce',
    color: '#EDC948',
    help: 'Recusa temporária: caixa cheia ou servidor fora do ar. A MailerSend tenta entregar de novo por conta própria.',
  },
  {
    key: 'spam_complaints',
    label: 'Spam',
    color: '#9C755F',
    help: 'O destinatário marcou a mensagem como spam. É o evento mais grave: derruba a reputação do domínio e afeta a entrega de todos os próximos envios.',
  },
  {
    key: 'unsubscribed',
    label: 'Descadastros',
    color: '#BAB0AC',
    help: 'Clicou no link de cancelar inscrição. Hoje é sempre zero, porque o rastreio de descadastro está desligado no domínio playdps.com — ausência de medição, não ausência de descadastros.',
  },
];

export const EVENT_LABELS: Record<EmailEvent, string> = {
  queued: 'Na fila',
  sent: 'Enviado',
  delivered: 'Entregue',
  opened: 'Aberto',
  clicked: 'Clicado',
  deferred: 'Adiado',
  soft_bounced: 'Soft bounce',
  hard_bounced: 'Hard bounce',
  spam_complaints: 'Spam',
  unsubscribed: 'Descadastrado',
};

/** Cor de fundo da etiqueta de evento na tabela. Eventos sem cor própria usam o cinza padrão. */
export const EVENT_COLORS: Partial<Record<EmailEvent, string>> = {
  queued: '#4E79A7',
  sent: '#4E79A7',
  delivered: '#59A14F',
  opened: '#F28E2B',
  clicked: '#B07AA1',
  hard_bounced: '#E15759',
  spam_complaints: '#E15759',
  soft_bounced: '#EDC948',
};

export const PAGE_SIZE = 25;

/** Teto de linhas da exportação, para não estourar a memória do browser. */
export const EXPORT_LIMIT = 5000;
